<template>
  <svg id="TrArtist" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340.14 108.9">
      <title>TrArtist</title>
      <g>
          <path :class="clases[0]" d="M29.56,31.43H11.63V15.53H62.54v15.9H44.61V117h-15Z" transform="translate(-11.13 -10.12)"/>
          <path :class="clases[1]" d="M62.49,65.84c0-12.76,0-20.78-.12-26.31H76.51c.13,1.34.36,4.57.36,12.78C79.29,43.52,85,38.23,93.69,38.22V58.3C83.2,58,77.31,61.74,77.31,76.43v40.74H62.49Z" transform="translate(-11.13 -10.12)"/>
          <path :class="clases[2]" d="M112.8,91.63l-4.16,25.54h-15L113,15.68h19.5l19.64,101.49H136.4l-4.18-25.54Zm16.74-15.78c-3.12-19.42-5.63-33.61-6.95-43.3h-.36c-1,9.34-3.68,24.59-6.77,43.3Z" transform="translate(-11.13 -10.12)"/>
          <path :class="clases[3]" d="M161.49,65.84c0-12.76,0-20.78-.12-26.31h14.14c.13,1.34.36,4.57.36,12.78,2.42-8.79,8.09-14.08,16.82-14.09V58.3c-10.49-.29-16.38,3.44-16.38,18.13v40.74H161.49Z" transform="translate(-11.13 -10.12)"/>
          <path :class="clases[4]" d="M199.36,39.38h8.41V20h14.8v19.4h9.91v14.7h-9.91V96.56c0,4.51.68,7.07,5.3,7.07a14,14,0,0,0,3.65-.31v13.17c-2.72,1.41-6.74,1.58-9.06,1.58-10.26,0-14.69-4.59-14.69-18.54V54.08h-8.41Z" transform="translate(-11.13 -10.12)"/>
          <path :class="clases[5]" d="M241.92,39.53h14.82v77.64H241.92ZM242,10.62h14.82v17.7H242Z" transform="translate(-11.13 -10.12)"/>
          <path :class="clases[6]" d="M282.34,93.68c.07,5.29,2.24,11.2,8.33,11.2,4.91,0,7.24-3.13,7.24-8.21,0-5.49-2-8.49-9.62-11.89C273.15,78,269.41,71.62,269.41,60.36c0-10.56,5.51-22.29,20.82-22.29,16.85,0,20.93,14,20.94,24.17H297c0-2.75-.26-10.53-7.13-10.53-3.93,0-6.05,3-6.05,7.31,0,4.92,2.33,7.19,10,10.63,13.56,6.06,18.71,12.31,18.71,24.87,0,15.27-7.9,24-22.46,24-15.34,0-22.19-11-22.25-24.84Z" transform="translate(-11.13 -10.12)"/>
          <path :class="clases[7]" d="M317.65,39.53h8.41V20.13h14.81v19.4h9.91v14.7h-9.91V96.71c0,4.51.67,7.08,5.29,7.08a13.91,13.91,0,0,0,3.65-.32v13.17c-2.71,1.41-6.74,1.58-9.05,1.58-10.26,0-14.7-4.59-14.7-18.54V54.23h-8.41Z" transform="translate(-11.13 -10.12)"/>
      </g>
  </svg>
</template>
<script>
export default {
  name: 'logo-animado',
  data () {
    return {
      porcentaje: 0
    }
  },
  mounted () {
    setInterval(() => this.porcentaje = this.porcentaje + 10, 100) // eslint-disable-line
  },
  computed: {
    clases: function () {
      let nuevasClases = [
        'sinFondo',
        'sinFondo',
        'sinFondo',
        'sinFondo',
        'sinFondo',
        'sinFondo',
        'sinFondo',
        'sinFondo'
      ]
      if (this.porcentaje) {
        const total = 8
        let cantMostrar = Math.round((this.porcentaje * total) / 100)
        if (cantMostrar > total) {
          cantMostrar = total
        }
        for (let j = 0; j < cantMostrar; j++) {
          nuevasClases[j] = 'texto'
        }
      }
      return nuevasClases
    }
  }
}
</script>

<style scoped>
.sinFondo {
    fill: transparent;
    stroke: black;
}
.texto {
    fill: black;
    stroke: none;
}
</style>
